import { render } from "./split-section.vue?vue&type=template&id=7d59fe5a"
import script from "./split-section.vue?vue&type=script&lang=js"
export * from "./split-section.vue?vue&type=script&lang=js"

import "./split-section.vue?vue&type=style&index=0&id=7d59fe5a&lang=scss"

import exportComponent from "/buddy/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__